export default class KendoTemplateLoader {
    constructor() {
        this.templatePath = '/js/templates';
        this.templateExtension = 'htm';
        this.templateSuffix = '';
        this.pendingLoads = {};
    }
    require(...templates) {
        return $.Deferred((promise) => {
            const templatePromises = $.map(templates, (template) => {
                if (typeof (template) === 'string') {
                    return this.getTemplate(template);
                }
                return this.getTemplate(template.name, template.file);
            });
            $.when(...templatePromises).done(promise.resolve);
        });
    }
    getTemplate(name, file) {
        const resultingFile = file || name;
        const dfd = $.Deferred();
        $.when(KendoTemplateLoader.lookupTemplate(name))
            .done(() => {
            dfd.resolve();
        })
            .fail(() => {
            $.when(this.loadTemplate(name, resultingFile))
                .then(dfd.resolve)
                .fail(dfd.reject);
        });
        return dfd;
    }
    static lookupTemplate(name) {
        const templateScriptElement = $(`script[type="text/x-kendo-template"][name="${name}"]`);
        const dfd = $.Deferred();
        if (templateScriptElement.length) {
            dfd.resolve(templateScriptElement.text());
        }
        else {
            dfd.reject();
        }
        return dfd;
    }
    loadTemplate(name, file) {
        let resultingFile = file || name;
        resultingFile = resultingFile.split('--').join('/');
        const dfd = $.Deferred();
        const pendingDownload = this.pendingLoads[resultingFile];
        if (pendingDownload) {
            pendingDownload.then((data) => {
                dfd.resolve(data);
            });
            return dfd;
        }
        this.pendingLoads[resultingFile] = dfd;
        $.ajax({
            url: this.getTemplateFilePath(resultingFile),
            dataType: 'html'
        }).then((data) => {
            const resultingData = data.trim();
            this.writeTemplate(name, resultingData);
            this.resolveChildTemplates(resultingData)
                .then(() => {
                dfd.resolve(resultingData);
            });
        }).fail((e) => {
            dfd.reject(e);
        });
        return dfd;
    }
    resolveChildTemplates(body) {
        const dataTemplateRegex = /\bdata-(?:[A-z0-9]+-)*template=["'](.+?)["']/gi;
        let match = [];
        const promises = [];
        while (match = dataTemplateRegex.exec(body)) { //eslint-disable-line
            let dependencyName = match[1];
            const suffixMatchPosition = dependencyName.indexOf(this.templateSuffix);
            if ((suffixMatchPosition !== -1)
                && ((suffixMatchPosition + this.templateSuffix.length) === dependencyName.length)) {
                dependencyName = dependencyName.substr(0, suffixMatchPosition);
            }
            promises.push(this.getTemplate(dependencyName));
        }
        return $.when(...promises);
    }
    writeTemplate(name, body, target) {
        let t;
        if (typeof target === "string") {
            t = $(target);
        }
        else {
            t = target || $('body');
        }
        const el = document.createElement('script');
        el.type = 'text/x-kendo-template';
        el.text = body;
        el.setAttribute('name', name);
        el.setAttribute('id', name + this.templateSuffix);
        t.append(el);
    }
    getTemplateFilePath(name) {
        return `${this.templatePath}/${name}.${this.templateExtension}`;
    }
}
